// Conjunto de dados em memória usado pelo modo mock (npm run start:mock).
// Os dados vivem enquanto a aba estiver aberta; criações/ações são refletidas na sessão.

export const MOCK_PORTFOLIO_ID = '11111111-1111-1111-1111-111111111111';
const SUB_TIC = '22222222-2222-2222-2222-222222222221';
const SUB_GESTAO = '22222222-2222-2222-2222-222222222222';

type Dict = Record<string, unknown>;

function uuid(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const mockStore = {
  portfolios: [
    {
      id: MOCK_PORTFOLIO_ID,
      anoExecucao: 2026,
      anoReferenciaConsolidacao: 2025,
      nome: 'Portfólio Institucional 2026',
      status: 'EM_PRIORIZACAO',
      dataLimiteConsolidacao: '2026-03-31',
      observacoesGovernanca: 'Ciclo em priorização multicritério.',
    },
    {
      id: 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa',
      anoExecucao: 2025,
      anoReferenciaConsolidacao: 2024,
      nome: 'Portfólio Institucional 2025',
      status: 'PUBLICADO_BCG',
      referenciaPublicacaoBcg: 'BCG nº 045/2025',
      publicadoEm: '2025-01-15',
    },
  ] as Dict[],

  /** Marcos de cronograma por portfolioId (modo mock). */
  cronogramaMarcos: {} as Record<string, Dict[]>,

  subportfolios: [
    {
      id: SUB_TIC,
      nome: 'Subportfólio de TIC',
      areaTematicaArt7: 'TIC',
      gestorSubportfolioId: 'GESTOR-TIC-01',
      portfolioId: MOCK_PORTFOLIO_ID,
      status: 'ATIVO',
      criadoEm: '2026-01-10T12:00:00Z',
      atualizadoEm: '2026-02-01T12:00:00Z',
    },
    {
      id: SUB_GESTAO,
      nome: 'Subportfólio de Melhoria da Gestão',
      areaTematicaArt7: 'MELHORIA_GESTAO',
      gestorSubportfolioId: 'GESTOR-GES-01',
      portfolioId: MOCK_PORTFOLIO_ID,
      status: 'ATIVO',
      criadoEm: '2026-01-12T12:00:00Z',
      atualizadoEm: '2026-02-03T12:00:00Z',
    },
    {
      id: '22222222-2222-2222-2222-222222222223',
      nome: 'Subportfólio de Logística (sem portfólio)',
      areaTematicaArt7: 'LOGISTICA_FROTA_MATERIAL',
      gestorSubportfolioId: 'GESTOR-LOG-01',
      status: 'ATIVO',
      criadoEm: '2026-02-01T12:00:00Z',
      atualizadoEm: '2026-02-01T12:00:00Z',
    },
  ] as Dict[],

  programas: [
    {
      id: '33333333-3333-3333-3333-333333333331',
      nome: 'Programa de Modernização Tecnológica',
      objetivoEstrategico: 'Ampliar a capacidade tecnológica da corporação.',
      gerenteProgramaId: 'GERENTE-PRG-01',
      prazoDesenvolvimentoInicio: '2026-01-01',
      prazoDesenvolvimentoFim: '2027-12-31',
      previsaoOrcamentaria: 4500000,
      estruturaAnaliticaPrograma: 'EAP-001',
      metas: [{ descricao: 'Digitalizar 80% dos processos', prazo: '2027-06-30' }],
      indicadores: [
        { codigo: 'IND-01', descricao: 'Processos digitalizados', unidadeMedida: '%', meta: '80' },
      ],
      projetoIds: ['44444444-4444-4444-4444-444444444441'],
      subportfolioId: SUB_TIC,
      status: 'EM_EXECUCAO',
      criadoEm: '2026-01-20T12:00:00Z',
      atualizadoEm: '2026-02-10T12:00:00Z',
    },
    {
      id: '33333333-3333-3333-3333-333333333332',
      nome: 'Programa de Excelência em Gestão',
      objetivoEstrategico: 'Elevar a maturidade de gestão das unidades.',
      gerenteProgramaId: 'GERENTE-PRG-02',
      prazoDesenvolvimentoFim: '2027-06-30',
      previsaoOrcamentaria: 1200000,
      metas: [],
      indicadores: [],
      projetoIds: [],
      subportfolioId: SUB_GESTAO,
      status: 'RASCUNHO',
      criadoEm: '2026-02-15T12:00:00Z',
      atualizadoEm: '2026-02-15T12:00:00Z',
    },
    {
      id: '33333333-3333-3333-3333-333333333333',
      nome: 'Programa de Comunicação Institucional',
      objetivoEstrategico: 'Fortalecer a imagem institucional.',
      gerenteProgramaId: 'GERENTE-PRG-03',
      prazoDesenvolvimentoFim: '2028-06-30',
      previsaoOrcamentaria: 800000,
      metas: [],
      indicadores: [],
      projetoIds: [],
      status: 'RASCUNHO',
      criadoEm: '2026-03-01T12:00:00Z',
      atualizadoEm: '2026-03-01T12:00:00Z',
    },
  ] as Dict[],

  projetos: [
    {
      id: '44444444-4444-4444-4444-444444444441',
      nome: 'Implantação de Data Center',
      natureza: 'ESTRATEGICO',
      tipoInstitucional: 'TI_IN04',
      faseCiclo: 'EXECUCAO',
      gerenteProjetoId: 'GERENTE-PROJ-01',
      escopoPreliminar: 'Construção e ativação do novo data center.',
      subportfolioId: SUB_TIC,
      programaId: '33333333-3333-3333-3333-333333333331',
      prazoConclusao: '2026-08-30',
    },
    {
      id: '44444444-4444-4444-4444-444444444442',
      nome: 'Capacitação em Gestão de Projetos',
      natureza: 'NAO_ESTRATEGICO',
      tipoInstitucional: 'ENSINO_TREINAMENTO_CAPACITACAO',
      faseCiclo: 'PLANEJAMENTO',
      gerenteProjetoId: 'GERENTE-PROJ-02',
      escopoPreliminar: 'Formação de 200 servidores em GP.',
      subportfolioId: SUB_GESTAO,
      prazoConclusao: '2026-06-15',
    },
    {
      id: '44444444-4444-4444-4444-444444444443',
      nome: 'Modernização da Frota',
      natureza: 'ESTRATEGICO',
      tipoInstitucional: 'AQUISICAO_BENS',
      faseCiclo: 'INICIACAO',
      gerenteProjetoId: 'GERENTE-PROJ-03',
      escopoPreliminar: 'Renovação de viaturas operacionais.',
      subportfolioId: SUB_GESTAO,
    },
    {
      id: '44444444-4444-4444-4444-444444444444',
      nome: 'Portal de Transparência',
      natureza: 'NAO_ESTRATEGICO',
      tipoInstitucional: 'MELHORIA_GESTAO',
      faseCiclo: 'INICIACAO',
      gerenteProjetoId: 'GERENTE-PROJ-04',
      escopoPreliminar: 'Publicação de indicadores para cidadãos.',
    },
  ] as Dict[],

  demandas: [
    {
      id: '55555555-5555-5555-5555-555555555551',
      titulo: 'Sistema de Ocorrências Integrado',
      descricao: 'Unificar o registro de ocorrências entre unidades.',
      areaTematica: 'TIC',
      fase: 'TRIAGEM',
      subportfolioId: SUB_TIC,
      opmDemandanteId: 'OPM-01',
      prazoConclusao: '2026-06-09',
    },
    {
      id: '55555555-5555-5555-5555-555555555552',
      titulo: 'Painel de Indicadores Estratégicos',
      descricao: 'Dashboard executivo para o Estado-Maior.',
      areaTematica: 'MELHORIA_GESTAO',
      fase: 'ELABORACAO',
      subportfolioId: SUB_GESTAO,
      opmDemandanteId: 'OPM-02',
      prazoConclusao: '2026-06-25',
    },
    {
      id: '55555555-5555-5555-5555-555555555553',
      titulo: 'Revisão de Processos de Logística',
      descricao: 'Mapear e otimizar o fluxo de suprimentos.',
      areaTematica: 'LOGISTICA_FROTA_MATERIAL',
      fase: 'TRIAGEM',
      subportfolioId: SUB_GESTAO,
      opmDemandanteId: 'OPM-03',
      prazoConclusao: '2026-05-28',
    },
    {
      id: '55555555-5555-5555-5555-555555555554',
      titulo: 'Integração com sistemas externos',
      descricao: 'APIs para troca de dados com órgãos parceiros.',
      areaTematica: 'TIC',
      fase: 'ELABORACAO',
      opmDemandanteId: 'OPM-04',
    },
  ] as Dict[],

  alertasPortfolio: [
    { tipo: 'PRAZO', criticidade: 'ALTA', mensagem: 'Consolidação do portfólio vence em 10 dias.' },
    { tipo: 'CAPACIDADE', criticidade: 'MEDIA', mensagem: 'Dois subportfólios sem relatório trimestral.' },
    { tipo: 'RISCO', criticidade: 'ALTA', mensagem: 'Projeto crítico em atraso na fase de execução.' },
  ] as Dict[],

  comissoes: [
    {
      id: 'cccccccc-cccc-cccc-cccc-cccccccccc01',
      protocolo: 'COM-EM-2026-001',
      titulo: 'Análise de trabalho',
      objetivo: 'Estudo de métodos de trabalho operacional',
      escopo: 'Levantamento documental PM-1 a PM-6',
      tipo: 'ESTUDO',
      status: 'INSTAURADA',
      prazoConclusao: '2026-08-23',
      atoCriacao: 'Portaria nº 001/2026',
      secaoProponente: 'CHEM',
      responsavelNome: 'Maj Lima',
      criadoEm: '2026-04-01T10:00:00Z',
      atualizadoEm: '2026-04-23T12:00:00Z',
    },
    {
      id: 'cccccccc-cccc-cccc-cccc-cccccccccc02',
      protocolo: 'COM-EM-2026-002',
      titulo: 'Revisão estrutural',
      objetivo: 'Revisar estrutura organizacional do EM',
      escopo: 'Análise comparativa e proposta de atualização',
      tipo: 'ESPECIAL',
      status: 'EM_ANDAMENTO',
      prazoConclusao: '2026-10-30',
      atoCriacao: 'Det. nº 123/2024',
      secaoProponente: 'PM1',
      responsavelNome: 'Ten Cel Souza',
      progressoPercentual: 50,
      criadoEm: '2026-02-01T08:00:00Z',
      atualizadoEm: '2026-06-02T08:00:00Z',
    },
    {
      id: 'cccccccc-cccc-cccc-cccc-cccccccccc03',
      protocolo: 'COM-EM-2026-003',
      titulo: 'Análise de procedimentos administrativos',
      objetivo: 'Padronizar procedimentos administrativos internos',
      escopo: 'Mapeamento e proposta normativa',
      tipo: 'ESTUDO',
      status: 'EM_ANDAMENTO',
      prazoConclusao: '2026-11-15',
      secaoProponente: 'PM3',
      responsavelNome: 'Capt Barros',
      progressoPercentual: 38,
      criadoEm: '2026-01-10T08:00:00Z',
      atualizadoEm: '2026-05-31T08:00:00Z',
    },
    {
      id: 'cccccccc-cccc-cccc-cccc-cccccccccc04',
      protocolo: 'COM-EM-2026-004',
      titulo: 'Planejamento de saúde',
      objetivo: 'Plano de ações em saúde ocupacional',
      escopo: 'Diagnóstico e metas trimestrais',
      tipo: 'ESPECIAL',
      status: 'EM_ANDAMENTO',
      prazoConclusao: '2026-03-30',
      secaoProponente: 'PM2',
      responsavelNome: 'Maj Oliveira',
      progressoPercentual: 65,
      criadoEm: '2025-12-01T08:00:00Z',
      atualizadoEm: '2026-04-15T08:00:00Z',
    },
    {
      id: 'cccccccc-cccc-cccc-cccc-cccccccccc05',
      protocolo: 'COM-EM-2026-005',
      titulo: 'Aquisição de equipamentos',
      objetivo: 'Estudo de aquisição de equipamentos operacionais',
      escopo: 'Levantamento de necessidades PM-4',
      tipo: 'ESTUDO',
      status: 'EM_ANDAMENTO',
      prazoConclusao: '2026-04-20',
      secaoProponente: 'PM4',
      responsavelNome: 'Major Mendes',
      progressoPercentual: 42,
      criadoEm: '2026-01-20T08:00:00Z',
      atualizadoEm: '2026-04-10T08:00:00Z',
    },
    {
      id: 'cccccccc-cccc-cccc-cccc-cccccccccc06',
      protocolo: 'COM-EM-2026-006',
      titulo: 'Análise de comunicação interna',
      objetivo: 'Revisão dos fluxos de comunicação interna',
      escopo: 'Entrevistas e proposta de melhoria',
      tipo: 'ESTUDO',
      status: 'ENCERRADA',
      prazoConclusao: '2026-05-01',
      secaoProponente: 'PM5',
      responsavelNome: 'Capt Gomes',
      progressoPercentual: 100,
      criadoEm: '2025-11-01T08:00:00Z',
      atualizadoEm: '2026-05-01T08:00:00Z',
    },
  ] as Dict[],

  auditEvents: [] as Dict[],

  comissaoMembros: {
    'cccccccc-cccc-cccc-cccc-cccccccccc02': [
      {
        id: 'mem-001',
        comissaoId: 'cccccccc-cccc-cccc-cccc-cccccccccc02',
        usuarioId: 'souza.tc',
        nomeExibicao: 'Ten Cel Souza',
        funcao: 'PRESIDENTE',
        designadoEm: '2026-02-05T08:00:00Z',
      },
      {
        id: 'mem-002',
        comissaoId: 'cccccccc-cccc-cccc-cccc-cccccccccc02',
        usuarioId: 'silva.mj',
        nomeExibicao: 'Maj Silva',
        funcao: 'MEMBRO',
        designadoEm: '2026-02-05T08:00:00Z',
      },
    ],
    'cccccccc-cccc-cccc-cccc-cccccccccc03': [
      {
        id: 'mem-003',
        comissaoId: 'cccccccc-cccc-cccc-cccc-cccccccccc03',
        usuarioId: 'barros.cp',
        nomeExibicao: 'Capt Barros',
        funcao: 'PRESIDENTE',
        designadoEm: '2026-01-15T08:00:00Z',
      },
    ],
  } as Record<string, Dict[]>,

  processosComissao: [
    {
      id: 'proc-001',
      numero: '123456',
      comissaoId: 'cccccccc-cccc-cccc-cccc-cccccccccc01',
      comissaoTitulo: 'Representação Técnica',
      status: 'EM_ANALISE',
      atualizadoEm: new Date().toISOString(),
    },
    {
      id: 'proc-002',
      numero: '654321',
      comissaoId: 'cccccccc-cccc-cccc-cccc-cccccccccc02',
      comissaoTitulo: 'Estrutural de Unidade',
      status: 'ANALISE_CONCLUIDA',
      atualizadoEm: '2024-04-15T10:00:00Z',
    },
    {
      id: 'proc-003',
      numero: '284930',
      comissaoId: 'cccccccc-cccc-cccc-cccc-cccccccccc05',
      comissaoTitulo: 'Aquisição de Equipamentos',
      status: 'ANALISE_CONCLUIDA',
      atualizadoEm: '2024-04-12T10:00:00Z',
    },
    {
      id: 'proc-004',
      numero: '301992',
      comissaoId: 'cccccccc-cccc-cccc-cccc-cccccccccc03',
      comissaoTitulo: 'Administração Interna',
      status: 'ATRASADO',
      atualizadoEm: '2024-04-05T10:00:00Z',
    },
    {
      id: 'proc-005',
      numero: '418277',
      comissaoId: 'cccccccc-cccc-cccc-cccc-cccccccccc04',
      comissaoTitulo: 'Planejamento de saúde',
      status: 'ATRASADO',
      atualizadoEm: '2026-04-01T10:00:00Z',
    },
    {
      id: 'proc-006',
      numero: '509881',
      comissaoId: 'cccccccc-cccc-cccc-cccc-cccccccccc02',
      comissaoTitulo: 'Revisão estrutural',
      status: 'EM_ANALISE',
      atualizadoEm: '2026-06-02T08:00:00Z',
    },
  ] as Dict[],

  processoTramitacaoHistorico: {
    'proc-001': [
      {
        id: 'ev-001',
        processoId: 'proc-001',
        tipo: 'CRIACAO',
        descricao: 'Foi criado por Cap Flavio',
        autorNome: 'Cap Flavio',
        ocorridoEm: (() => {
          const d = new Date();
          d.setHours(9, 45, 0, 0);
          return d.toISOString();
        })(),
      },
      {
        id: 'ev-002',
        processoId: 'proc-001',
        tipo: 'ENCAMINHAMENTO',
        descricao: 'Enviado para Corregedoria',
        destinatario: 'CORREGEDORIA',
        ocorridoEm: (() => {
          const d = new Date();
          d.setHours(12, 30, 0, 0);
          return d.toISOString();
        })(),
      },
      {
        id: 'ev-003',
        processoId: 'proc-001',
        tipo: 'ENCAMINHAMENTO',
        descricao: 'Enviado para Corregedoria',
        destinatario: 'CORREGEDORIA',
        ocorridoEm: '2024-03-28T15:10:00Z',
      },
    ],
  } as Record<string, Dict[]>,

  documentosComissao: [
    {
      id: 'doc-001',
      nome: 'Parecer - PM-3.pdf',
      categoria: 'PARECER',
      comissaoId: 'cccccccc-cccc-cccc-cccc-cccccccccc03',
      comissaoTitulo: 'Análise de procedimentos administrativos',
      comissaoProtocolo: 'COM-EM-2026-003',
      versaoAtual: 3,
      atualizadoEm: '2026-06-01T10:00:00Z',
    },
    {
      id: 'doc-002',
      nome: 'Parecer Conclusivo.pdf',
      categoria: 'PARECER',
      comissaoId: 'cccccccc-cccc-cccc-cccc-cccccccccc02',
      comissaoTitulo: 'Revisão estrutural',
      comissaoProtocolo: 'COM-EM-2026-002',
      versaoAtual: 2,
      atualizadoEm: '2026-05-15T10:00:00Z',
    },
    {
      id: 'doc-003',
      nome: 'Parecer Preliminar.pdf',
      categoria: 'PARECER',
      comissaoId: 'cccccccc-cccc-cccc-cccc-cccccccccc02',
      comissaoTitulo: 'Revisão estrutural',
      comissaoProtocolo: 'COM-EM-2026-002',
      versaoAtual: 1,
      atualizadoEm: '2026-03-10T10:00:00Z',
    },
    {
      id: 'doc-004',
      nome: 'Nota Técnica-Divulgação de Procedimentos.pdf',
      categoria: 'NOTA_TECNICA',
      comissaoId: 'cccccccc-cccc-cccc-cccc-cccccccccc02',
      comissaoTitulo: 'Revisão estrutural',
      comissaoProtocolo: 'COM-EM-2026-002',
      versaoAtual: 2,
      atualizadoEm: '2026-04-20T10:00:00Z',
    },
    {
      id: 'doc-005',
      nome: 'Nota Técnica 01/2024.pdf',
      categoria: 'NOTA_TECNICA',
      comissaoId: 'cccccccc-cccc-cccc-cccc-cccccccccc01',
      comissaoTitulo: 'Análise de trabalho',
      comissaoProtocolo: 'COM-EM-2026-001',
      versaoAtual: 1,
      atualizadoEm: '2024-01-15T10:00:00Z',
    },
    {
      id: 'doc-006',
      nome: 'Nota Técnica 02/2024.pdf',
      categoria: 'NOTA_TECNICA',
      comissaoId: 'cccccccc-cccc-cccc-cccc-cccccccccc05',
      comissaoTitulo: 'Aquisição de equipamentos',
      comissaoProtocolo: 'COM-EM-2026-005',
      versaoAtual: 1,
      atualizadoEm: '2024-02-20T10:00:00Z',
    },
  ] as Dict[],

  documentoVersoes: {
    'doc-001': [
      {
        id: 'ver-001-3',
        documentoId: 'doc-001',
        versao: 3,
        nomeArquivo: 'Parecer - PM-3.pdf',
        enviadoPor: 'Maj Lima',
        enviadoEm: '2026-06-01T10:00:00Z',
        atual: true,
      },
      {
        id: 'ver-001-2',
        documentoId: 'doc-001',
        versao: 2,
        nomeArquivo: 'Parecer - PM-3-v2.pdf',
        enviadoPor: 'Capt Souza',
        enviadoEm: '2026-04-15T14:30:00Z',
        atual: false,
      },
      {
        id: 'ver-001-1',
        documentoId: 'doc-001',
        versao: 1,
        nomeArquivo: 'Parecer - PM-3-v1.pdf',
        enviadoPor: 'Cap Flavio',
        enviadoEm: '2026-03-01T09:45:00Z',
        atual: false,
      },
    ],
    'doc-002': [
      {
        id: 'ver-002-2',
        documentoId: 'doc-002',
        versao: 2,
        nomeArquivo: 'Parecer Conclusivo.pdf',
        enviadoPor: 'Ten Cel Souza',
        enviadoEm: '2026-05-15T10:00:00Z',
        atual: true,
      },
      {
        id: 'ver-002-1',
        documentoId: 'doc-002',
        versao: 1,
        nomeArquivo: 'Parecer Conclusivo-rascunho.pdf',
        enviadoPor: 'Ten Cel Souza',
        enviadoEm: '2026-04-01T11:00:00Z',
        atual: false,
      },
    ],
    'doc-003': [
      {
        id: 'ver-003-1',
        documentoId: 'doc-003',
        versao: 1,
        nomeArquivo: 'Parecer Preliminar.pdf',
        enviadoPor: 'Maj Silva',
        enviadoEm: '2026-03-10T10:00:00Z',
        atual: true,
      },
    ],
    'doc-004': [
      {
        id: 'ver-004-2',
        documentoId: 'doc-004',
        versao: 2,
        nomeArquivo: 'Nota Técnica-Divulgação de Procedimentos.pdf',
        enviadoPor: 'Capt Barros',
        enviadoEm: '2026-04-20T10:00:00Z',
        atual: true,
      },
      {
        id: 'ver-004-1',
        documentoId: 'doc-004',
        versao: 1,
        nomeArquivo: 'Nota Técnica-Divulgação-rascunho.pdf',
        enviadoPor: 'Capt Barros',
        enviadoEm: '2026-03-05T08:00:00Z',
        atual: false,
      },
    ],
    'doc-005': [
      {
        id: 'ver-005-1',
        documentoId: 'doc-005',
        versao: 1,
        nomeArquivo: 'Nota Técnica 01/2024.pdf',
        enviadoPor: 'Maj Oliveira',
        enviadoEm: '2024-01-15T10:00:00Z',
        atual: true,
      },
    ],
    'doc-006': [
      {
        id: 'ver-006-1',
        documentoId: 'doc-006',
        versao: 1,
        nomeArquivo: 'Nota Técnica 02/2024.pdf',
        enviadoPor: 'Major Mendes',
        enviadoEm: '2024-02-20T10:00:00Z',
        atual: true,
      },
    ],
  } as Record<string, Dict[]>,
};

export function page(content: Dict[]): Dict {
  return {
    content,
    totalElements: content.length,
    totalPages: 1,
    page: 0,
    size: content.length,
  };
}

export function novoId(): string {
  return uuid();
}
